import script from "./RewardBubbleView.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardBubbleView.vue?vue&type=script&setup=true&lang=js"

import "./RewardBubbleView.vue?vue&type=style&index=0&id=54d4bd13&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d4bd13"]])

export default __exports__